<mat-toolbar color="primary">
  <search-display></search-display>
  <scope-display></scope-display>
  <user-menu></user-menu>
</mat-toolbar>
